import {
  Button,
  Modal,
  Select,
  Input,
  DatePicker,
  Checkbox,
  Form,
  message,
  Row,
  Col,
} from "antd";
import { useState, useEffect, useMemo } from "react";

import "./audits.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import { GlobalStateContext } from "../../../utils/GlobalStateContext";
import { useContext } from "react";
import moment from "moment";
import DuplicateTransactionReasonForm from "./duplicateTransactionReasonForm";
import { JsonToExcel } from "react-json-to-excel";

import "react-datetime/css/react-datetime.css";
import AuditBackDateReasonForm from "./auditBackDateReasonForm";
import { exportJson } from "../../../utils/export";
import DownloadAllModal from "./downloadAllModal";
import CustomLoader from "../../common/customLoader";
import TopContainerHeader from "../../../components/molecules/TopComponentHeader";

import TableContent from "../../../components/atoms/TableContent";
import media from "../../../media";
import {
  completeAuditsThunk,
  deleteAuditsThunk,
  fetchAuditsThunk,
  fetchProcessesByDeptThunk,
  fetchAuditFormByProcessThunk,
  fetchUserByRoleAndClientThunk,
  fetchClientsThunk,
  fetchDepartmentsThunk,
  softDeleteAuditsThunk,
  downloadAllThunk,
} from "../../../store/thunks/auditsThunk";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { AvatarCell, getSectionKeyFromRoute } from "../../../utils/Constants";
import { fetchClientsByDeptThunk } from "../../../store/thunks/clientsThunk";
import { createAccessMap, hasPermission } from "../../../utils/permissions";
import Unauthorized from "../../layouts/Unauthorized";

const Audits = ({ children }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const { globalState, setGlobalState } = useContext(GlobalStateContext);

  const currentPath = location.pathname.replace("/", "");
  const [tableForm] = Form.useForm();
  const rawAccess = useSelector((state) => state.auth.access);
  const { list, pageInfo, count, loading } = useSelector(
    (state) => state.qmsAudits,
  );

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: Number(process.env.REACT_APP_DEFAULT_PAGINATION_PAGESIZE || 50),
  });
  const shouldShowPagination = count > pagination.pageSize;
  const tablePagination = shouldShowPagination
    ? {
        current: pagination.current,
        pageSize: pagination.pageSize,
        total: count,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        locale: { items_per_page: "" },
        onChange: (page, pageSize) => {
          setPagination({ current: page, pageSize });
        },
      }
    : false;

  const slsRole = secureLocalStorage.getItem("role");
  const slsToken = secureLocalStorage.getItem("accessToken");
  const slsLIUId = secureLocalStorage.getItem("lIUId");
  const slsReportingSupervisor = secureLocalStorage.getItem("tl");
  const auditType =
    location.state?.auditType || secureLocalStorage.getItem("auditType") || "";

  const currentAuditSection = getSectionKeyFromRoute(
    location.pathname,
    slsRole,
    auditType,
  );
  {
    /*Declaring states*/
  }

  const [selectionType, setSelectionType] = useState("checkbox");
  const [searchData, setSearchData] = useState([]),
    [selectedRowsArray, setSelectedRowsArray] = useState([]),
    [clients, setClients] = useState([]),
    [departments, setDepartments] = useState([]),
    [tasks, setTasks] = useState([]),
    [forms, setForms] = useState([]),
    [agents, setAgents] = useState([]);
  const [clientId, setClientId] = useState(),
    [formId, setFormId] = useState(),
    [agentId, setAgentId] = useState(),
    [departmentId, setDepartmentId] = useState(),
    [processId, setProcessId] = useState(),
    [transactionId, setTransactionId] = useState(),
    [transactionDate, setTransactionDate] = useState(),
    [auditDateTime, setAuditDateTime] = useState(),
    [transactionAmount, setTransactionAmount] = useState(),
    [invoiceCount, setInvoiceCount] = useState(),
    [insuredName, setInsuredName] = useState();
  /*setagentCVal, setProcessDepCVal, setAformVal states are for reset respected values for Process as well as Form*/
  const [agentCVal, setAgentCVal] = useState(),
    [processDepCVal, setProcessDepCVal] = useState(),
    [aformVal, setAformVal] = useState();
  /*setAuditFormInput state is used to show Perform Audit selected fields on Audit Form*/
  const [auditFormInput, setAuditFormInput] = useState({
    Stage: { icon: "auditStag", value: "Audit Pending" },
    Auditor: { icon: "auditAuditor", value: secureLocalStorage.getItem("lIU") },
    "Audit Score": {
      icon: "auditScoree",
      value: "0.00%",
    },
  });

  const [isActiveLoad, setIsActiveLoad] = useState("isActionLoad");
  const [listItems, setListItems] = useState([]);
  const [auditFormErrors, setAuditFormErrors] = useState({});
  const [showLoader, setShowLoader] = useState(true);
  const [allTransactionIdsArr, setAllTransactionIdsArr] = useState([]);
  const [auditLists, setAuditLists] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false),
    [isDownloadModalOpen, setIsDownloadModalOpen] = useState(false),
    [auditBackDateReasonVisible, setAuditBackDateReasonVisible] =
      useState(false),
    [visible, setVisible] = useState(false),
    [isModalVisible, setIsModalVisible] = useState(false),
    [isDeleteModalVisible, setIsDeleteModalVisible] = useState(false),
    [DownloadAllModalVisible, setDownloadAllModalVisible] = useState(false);
  const [transactionDuplicateReason, setTransactionDuplicateReason] =
      useState(""),
    [auditBackDateReason, setAuditBackDateReason] = useState("");
  const [auditFor, setAuditFor] = useState("agent");
  const accessMap = useMemo(() => {
    return createAccessMap(rawAccess);
  }, [rawAccess]);

  const hasViewAccess = hasPermission(
    accessMap,
    ["qMSAuditsMy", "qMSAudits", "qMSAuditsAuditors"],
    "view",
  );

  // Fetch Audits List
  useEffect(() => {
    const fetchData = async () => {
      try {
        setShowLoader(true);
        const allKeys = Object.keys(localStorage);
        let removeItems;
        switch (secureLocalStorage.getItem("fromComponent")) {
          case "audits": {
            removeItems = [
              "@secure.n.totalAuditedCount",
              "@secure.s.auditScore",
              "@secure.j.parameterSelectedList",
              "@secure.j.auditFormInput",
              "@secure.s.auditFormCall",
              "@secure.n.auditedQuestionScoreCount",
              "@secure.n.auditedQuestionCount",
              "@secure.j.countMap",
              "@secure.s.clickedLink",
              "@secure.j.timeStampsDetails",
              "@secure.n.weightageFlag",
              "@secure.j.updatedQMF",
              "@secure.s.savedAuditId",
              "@secure.b.auditedFormSubmit",
              "@secure.s.aID",
              "@secure.j.savePayloadRequestParams",
            ];
            break;
          }
          default: {
            break;
          }
        }
        allKeys &&
          allKeys.forEach((key) => {
            if (removeItems && removeItems.includes(key)) {
              localStorage.removeItem(key);
            }
          });
        const hasSearchedValue = secureLocalStorage.getItem("hasSearchedValue")
          ? "yes"
          : "";
        const searchKeyword = secureLocalStorage.getItem("searchKeyword") || "";

        const res = await dispatch(
          fetchAuditsThunk({
            searchData: searchData,
            setSearchData: setSearchData,
            selectedRowsArray: selectedRowsArray,
            setSelectedRowsArray: setSelectedRowsArray,
            auditType,
            searchIn: currentPath,
            callActionFrom: currentPath,
            hasSearchedValue,
            searchKeyword,
            route: currentPath,
            pagination: {
              current: pagination.current,
              page: pagination.current,
              pageSize: pagination.pageSize,
            },
            allTransactionIdsArr: allTransactionIdsArr,
            setAllTransactionIdsArr: setAllTransactionIdsArr,
          }),
        ).unwrap();
        if (res?.meta?.allTransactionIdsArr) {
          setAllTransactionIdsArr(res.meta.allTransactionIdsArr);
        }
        if (res?.meta?.auditLists) {
          setAuditLists(res?.meta?.auditLists);
        }
      } catch (err) {
        console.error("Error fetching audits:", err);
      } finally {
        setShowLoader(false);
      }
    };

    fetchData();
  }, [
    currentPath,
    pagination.current,
    pagination.pageSize,
    auditType,
    dispatch,
  ]);

  {
    /*Defining functions*/
  }
  {
    /*PerformAudit Popup Form*/
  }
  const showModal = () => {
    const allKeys = Object.keys(localStorage);
    // Loop through the keys and remove items that are not the specific item
    let exceptItems = [
      "@secure.s.lIU",
      "@secure.s.lIUId",
      "@secure.s.role",
      "@secure.s.accessToken",
      "@secure.s.accessTokenExpiry",
      "@secure.s.refreshToken",
      "@secure.s.refreshTokenExpiry",
    ];
    let removeItems = [
      "@secure.s.isSubMenuActive",
      "@secure.j.auditFormInput",
      "@secure.s.auditFormCall",
      "@secure.n.totalAuditedCount",
      "@secure.j.parameterSelectedList",
      "@secure.n.auditedQuestionScoreCount",
      "@secure.n.auditedQuestionCount",
      "@secure.j.countMap",
      "@secure.s.clickedLink",
      "@secure.s.auditScore",
      "@secure.j.timeStampsDetails",
      "@secure.n.weightageFlag",
      "@secure.j.updatedQMF",
      "@secure.s.savedAuditId",
      "@secure.j.savePayloadRequestParams",
    ];
    allKeys.forEach((key) => {
      /* if (!exceptItems.includes(key)) {
        localStorage.removeItem(key);
      } */
      if (removeItems.includes(key)) {
        localStorage.removeItem(key);
      }
    });
    setIsModalOpen(true);
  };

  {
    /*Setting state for showing Duplication Transaction ID popup as well as it value on Audits Detail Section*/
  }
  const onCreate = (values) => {
    values?.transactionDuplicateReason &&
      setTransactionDuplicateReason(values?.transactionDuplicateReason);
    setAuditFormInput({
      ...auditFormInput,
      "Reason for duplicate Transaction ID": {
        icon: "auditAgent",
        value: values?.transactionDuplicateReason,
      },
    });
    setVisible(false);
  };

  {
    /*Save Audit Back Date reason*/
  }
  const onCreateBackDateReason = (values) => {
    values?.auditBackDateReason &&
      setAuditBackDateReason(values?.auditBackDateReason);
    setAuditFormInput({
      ...auditFormInput,
      "Reason for Audit's back date": {
        icon: "auditAgent",
        value: values?.auditBackDateReason,
      },
    });
    setAuditBackDateReasonVisible(false);
  };

  {
    /*Audit Complete and Delete action*/
  }
  const handleAuditAction = async (params) => {
    switch (params) {
      case "complete":
        const payload = {
          role: slsRole,
          ids: globalState.selectedRowKeysChildInfo,
          markedAsCompleteBy: slsLIUId,
        };

        await dispatch(completeAuditsThunk(payload))
          .then((response) => {
            dispatch(
              fetchAuditsThunk({
                searchData: searchData,
                setSearchData: setSearchData,
                selectedRowsArray: selectedRowsArray,
                setSelectedRowsArray: setSelectedRowsArray,

                searchIn: currentPath,
                callActionFrom: currentPath,
                hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
                  ? "yes"
                  : "",
                searchKeyword:
                  secureLocalStorage.getItem("searchKeyword") || "",
                route: currentPath,
                pagination: {
                  current: pagination.current,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                },
                allTransactionIdsArr: allTransactionIdsArr,
                setAllTransactionIdsArr: setAllTransactionIdsArr,
              }),
            );
            setSelectedRowKeys([]);
          })
          .catch((error) => {});
        break;
      case "delete":
        let submitDeleteAuditFormModal = "";

        if (isDeleteModalVisible === true) {
          if (secureLocalStorage.getItem("role") === "admin") {
            submitDeleteAuditFormModal = "clickedDeleteAuditOK";
          }
          if (secureLocalStorage.getItem("role") === "qc") {
            submitDeleteAuditFormModal = "clickedDeleteAuditWithReasonOK";
          }
        }

        if (submitDeleteAuditFormModal === "clickedDeleteAuditOK") {
          try {
            setShowLoader(true);

            const payload = {
              role: slsRole,
              ids: globalState.selectedRowKeysChildInfo,
            };

            await dispatch(deleteAuditsThunk(payload)).unwrap();

            setIsDeleteModalVisible(false);

            await dispatch(
              fetchAuditsThunk({
                searchData: searchData,
                setSearchData: setSearchData,
                selectedRowsArray: selectedRowsArray,
                setSelectedRowsArray: setSelectedRowsArray,

                searchIn: currentPath,
                callActionFrom: currentPath,
                hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
                  ? "yes"
                  : "",
                searchKeyword:
                  secureLocalStorage.getItem("searchKeyword") || "",
                route: currentPath,
                pagination: {
                  current: pagination.current,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                },
                allTransactionIdsArr: allTransactionIdsArr,
                setAllTransactionIdsArr: setAllTransactionIdsArr,
              }),
            );
            setSelectedRowKeys([]);
          } catch (error) {
            message.error("Failed to delete audits");
          } finally {
            setShowLoader(false); // 🔥 THIS WAS MISSING
          }
        } else if (
          submitDeleteAuditFormModal === "clickedDeleteAuditWithReasonOK"
        ) {
          try {
            const values = await form.validateFields();
            setShowLoader(true);

            const payload = {
              role: slsRole,
              tl: slsReportingSupervisor,
              ids: globalState.selectedRowKeysChildInfo,
              auditDeleteReason: values.auditDeleteReason,
            };

            await dispatch(softDeleteAuditsThunk(payload)).unwrap();

            setIsDeleteModalVisible(false);

            await dispatch(
              fetchAuditsThunk({
                searchData,
                setSearchData,
                selectedRowsArray,
                setSelectedRowsArray,
                searchIn: currentPath,
                callActionFrom: currentPath,
                hasSearchedValue: secureLocalStorage.getItem("hasSearchedValue")
                  ? "yes"
                  : "",
                searchKeyword:
                  secureLocalStorage.getItem("searchKeyword") || "",
                route: currentPath,
                pagination: {
                  current: pagination.current,
                  page: pagination.current,
                  pageSize: pagination.pageSize,
                },
                allTransactionIdsArr,
                setAllTransactionIdsArr,
              }),
            );

            setSelectedRowKeys([]);
          } catch (error) {
            // Ignore validation errors
            if (!error?.errorFields) {
              console.error(error);
              message.error("Failed to delete audits");
            }
            setIsDeleteModalVisible(true);
          } finally {
            setShowLoader(false); // 🔥 THIS FIXES EVERYTHING
          }
        } else {
          setIsDeleteModalVisible(true);
          form.resetFields();
        }
        break;
    }
  };

  {
    /*PerformAudit - Submit click*/
  }
  const isValidTransactionAmount = (value) => {
    if (value === undefined || value === null || value === "") return true; // not required
    return /^\d*\.?\d*$/.test(value);
  };

  const isValidInvoiceCount = (value) => {
    if (value === undefined || value === null || value === "") return true; // not required
    return /^\d*$/.test(value);
  };
  const handleOk = () => {
    let hasError = false;

    if (transactionAmount && !/^\d+$/.test(transactionAmount)) {
      //!/^\d*\.?\d*$/.test
      hasError = true;
      setAuditFormErrors((state) => ({
        ...state,
        transactionAmount: "Only numbers are allowed",
        auditFor: slsRole === "tl" && !auditFor ? "Audit For is required" : "",
      }));
    }

    if (invoiceCount && !/^\d+$/.test(invoiceCount)) {
      hasError = true;
      setAuditFormErrors((state) => ({
        ...state,
        invoiceCount: "Only numbers are allowed",
      }));
    }

    if (hasError) return;

    let submitFormModal = "";
    if (isModalVisible === true) {
      submitFormModal = "clickedOK";
    }
    secureLocalStorage.removeItem("updatedQMF");
    secureLocalStorage.removeItem("auditedQuestionCount");
    secureLocalStorage.removeItem("auditScore");
    secureLocalStorage.removeItem("auditFormCall");
    secureLocalStorage.removeItem("savedAuditId");

    secureLocalStorage.removeItem("auditedFormSubmit");
    secureLocalStorage.removeItem("savePayloadRequestParams");
    secureLocalStorage.setItem("auditFormCall", "performAudit");
    if (backAuditDateChecked && auditBackDateReason === "") {
      setIsModalOpen(true);
      setAuditBackDateReasonVisible(true);
    } else if (
      allTransactionIdsArr.includes(transactionId) &&
      transactionDuplicateReason === ""
    ) {
      //Case: Duplicate Transaction ID Reason popup open
      setIsModalOpen(true);
      setVisible(true);
    } else if (
      clientId &&
      departmentId &&
      processId &&
      agentId &&
      formId &&
      transactionId &&
      transactionDate &&
      insuredName
    ) {
      let transactionDte = moment(transactionDate).format("YYYY-MM-DD");
      secureLocalStorage.setItem("auditFormInput", auditFormInput);

      if (submitFormModal === "clickedOK") {
        //Case: When all form fields are valid for submission then navigate to Audit View
        setIsModalOpen(false);
        setIsModalVisible(false);
        setVisible(true);
        navigate("/audits/" + formId, {
          state: {
            route: location.pathname,
            clientId,
            departmentId,
            auditorId: secureLocalStorage.getItem("lIUId"),
            agentId,
            auditFor,
            processId,
            transactionId,
            transactionDte,
            transactionDuplicateReason: transactionDuplicateReason,
            auditBackDateReason: auditBackDateReason,
            formMethd: "create",
            insuredName: insuredName,
            transactionAmount: transactionAmount,
            invoiceCount: invoiceCount,
          },
        });
        setAuditFormErrors({});
      } else {
        setIsModalOpen(true);
        setIsModalVisible(true);
      }
    } else {
      setIsModalOpen(true);

      {
        /*For showing form errors*/
      }
      if (
        auditFormInput &&
        auditFormInput?.Client === "Lisa Baker" &&
        auditFormInput?.Department === "Accounting" &&
        auditFormInput?.Process === "Cash Posting"
      ) {
        setAuditFormErrors((state) => ({
          ...state,
          client: clientId ? "" : "Client is required",
          department: departmentId ? "" : "Department is required",
          process: processId ? "" : "Process is required",
          agentId: agentId
            ? ""
            : `${
                slsRole === "tl" && auditFor === "atl" ? "ATL" : "Agent"
              } is required`,
          auditForm: formId ? "" : "Form is required",
          transactionId: transactionId ? "" : "Transaction ID is required",
          transactionDate: transactionDate
            ? ""
            : "Transaction Date is required",
          auditDateTime: auditDateTime ? "" : "Audit Date and Time is required",
          transactionAmount: transactionAmount
            ? ""
            : "Transaction Amount is required",
          invoiceCount: invoiceCount ? "" : "Invoice Count is required",
          insuredName: insuredName ? "" : "Insured Name is required",
        }));
      } else {
        setAuditFormErrors((state) => ({
          ...state,
          client: clientId ? "" : "Client is required",
          department: departmentId ? "" : "Department is required",
          process: processId ? "" : "Process is required",
          agentId: agentId
            ? ""
            : `${
                slsRole === "tl" && auditFor === "atl" ? "ATL" : "Agent"
              } is required`,
          auditForm: formId ? "" : "Form is required",
          transactionId: transactionId ? "" : "Transaction ID is required",
          transactionDate: transactionDate
            ? ""
            : "Transaction Date is required",
          auditDateTime: auditDateTime ? "" : "Audit Date and Time is required",
          transactionAmount: "",
          invoiceCount: "",
          insuredName: insuredName ? "" : "Insured Name is required",
        }));
      }
    }
  };

  {
    /*PerformAudit - Cancel click*/
  }
  const handleCancel = () => {
    setIsModalOpen(false);
  };

  {
    /*Calling audit detail page on its ID's click*/
  }
  const handleAuditDetailClickedLink = () => {
    secureLocalStorage.setItem("clickedLink", "auditsDetailLinkClick");
    secureLocalStorage.setItem("fromComponent", "audits");
  };

  {
    /*Fetch the list of Departments*/
  }
  const getDepartments = async () => {
    const payload = { route: "departments", action: "findAll" };

    await dispatch(fetchDepartmentsThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((department, index) => {
          temp.push({ label: department?.name, value: department?._id });
        });
        setDepartments(temp);
      })
      .catch((error) => {});
  };

  {
    /*Fetch the list of Processes*/
  }
  const getProcesses = async () => {
    const payload = {
      role: slsRole,
      department: departmentId,
    };

    await dispatch(fetchProcessesByDeptThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((task, index) => {
          temp.push({ label: task?.name, value: task?._id });
        });
        setTasks(temp);
      })
      .catch((error) => {});
  };

  {
    /*Fetch the list of audit forms*/
  }
  const getForms = async () => {
    const payload = {
      role: slsRole,
      process: processId,
    };

    await dispatch(fetchAuditFormByProcessThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((form, index) => {
          temp.push({ label: form?.formName, value: form?._id });
        });
        setForms(temp);
      })
      .catch((error) => {});
  };

  {
    /*Fetch the list of Clients*/
  }
  const getClients = async () => {
    const payload = {
      role: slsRole,
      department: departmentId,
    };

    await dispatch(fetchClientsByDeptThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((client, index) => {
          temp.push({ label: client?.name, value: client?._id });
        });

        setClients(temp);
      })
      .catch((error) => {});
  };

  {
    /*Fetch the list of agents*/
  }
  const getAgents = async () => {
    if (slsRole === "tl" && !auditFor) {
      return;
    }
    const payload = {
      reqRole: slsRole === "tl" ? auditFor : "agent",
      client: clientId,
    };

    await dispatch(fetchUserByRoleAndClientThunk(payload))
      .unwrap()
      .then((response) => {
        const temp = [];
        response?.map((agent, index) => {
          temp.push({
            label: agent?.name + " (Emp ID: " + agent.empID + ")",
            value: agent?._id,
          });
        });
        setAgents(temp);
      })
      .catch((error) => {});
  };

  {
    /*Export functionality on Audit Listing's table clicking on checkboxes*/
  }
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);

  const exportColumns = [
    { key: "Audit ID", path: "_id" },
    { key: "Auditor", path: "auditor.name" },
    { key: "Audit Score", path: "score" },
    { key: "Client", path: "client.name" },
    { key: "Department", path: "department.name" },
    { key: "Process", path: "process.name" },
    { key: "Audit Form", path: "auditForm.formName" },
    { key: "Audit Form Type", path: "hasWeightage" },
    { key: "Transaction ID", path: "transaction_id" },
    {
      key: "Transaction Date",
      path: "transactionDate",
      formatter: (value) => (value ? moment(value).format("YYYY-MM-DD") : ""),
    },
    { key: "Reason for Audit's back date", path: "auditBackDateReason" },
    {
      key: "Reason for duplicate Transaction ID",
      path: "transactionDuplicateReason",
    },
    { key: "Transaction Amount", path: "transactionAmount" },
    { key: "Invoice count", path: "invoiceCount" },
    { key: "Insured Name", path: "insuredName" },
    { key: "TL", path: "agentReportingSupervisor.name" },
    { key: "ATL", path: "agentAtl.name" },
    { key: "Status", path: "stage" },
    { key: "Agent Name", path: "agent.name" },
    { key: "Agent Emp ID", path: "agent.empID" },
    {
      key: "Maximum Possible Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedMaxQuestionCount : "",
    },
    {
      key: "Actual Score",
      path: "auditedScoreInfo",
      formatter: (value) =>
        value ? JSON.parse(value).auditedQuestionCount : "",
    },
    {
      key: "Fatal",
      path: "fatalNotFatalInfo",
      formatter: (value) => (value ? JSON.parse(value).fatal : ""),
    },
    {
      key: "Not Fatal",
      path: "fatalNotFatalInfo",
      formatter: (value) => (value ? JSON.parse(value).notFatal : ""),
    },
    {
      key: "Created At",
      path: "createdAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
    {
      key: "Updated At",
      path: "updatedAt",
      formatter: (value) =>
        value ? moment(value).format("YYYY-MM-DD HH:mm A") : "",
    },
  ];
  const rowSelection = {
    type: "checkbox",
    selectedRowKeys,
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedRowKeys(selectedRowKeys);

      exportJson(
        selectedRows,
        auditLists,
        "AuditReport",
        exportColumns,
        setGlobalState,
        globalState,
      );
    },
  };

  {
    /*Defining columns for Audit Listing*/
  }
  const columns = [
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditId.svg} alt="icon" />
            Audit ID
          </div>
        );
      },
      dataIndex: "id",
      render: (text, row) => {
        // Log row object to console
        return (
          <Link
            to={"/audits/" + row.id}
            state={{
              route: location.pathname,
              auditFormHasWeightage: row.hasWeightage,
              formMethd: row.formMethd,
              process: row.process?._id,
            }}
            style={{ color: "black" }}
          >
            <span
              className="rowstyle no-wrap bfont"
              style={{ color: "#1875CB" }}
              onClick={handleAuditDetailClickedLink}
            >
              {text}
            </span>
          </Link>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentIcon.svg} alt="icon" />
            Form
          </div>
        );
      },
      dataIndex: "form",
      render: (text, row) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return secureLocalStorage.getItem("role") === "tl" ||
          secureLocalStorage.getItem("role") === "atl" ? (
          <span className="rowstyle no-wrap" title={text}>
            {truncatedText}
          </span>
        ) : (
          <Link
            to={"/auditForms/" + row.formId}
            state={{ route: "/auditForms" }}
            style={{ color: "black" }}
          >
            <span
              className="rowstyle no-wrap bfont"
              style={{ color: "#1875CB" }}
              onClick={() =>
                secureLocalStorage.setItem("fromComponent", "audits")
              }
              title={text}
            >
              {truncatedText}
            </span>
          </Link>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.transactionId.svg} alt="icon" />
            Transaction ID
          </div>
        );
      },
      dataIndex: "transaction_id",
      render: (text, record, index) => {
        const maxLength = 15;
        const truncatedText =
          text && text.length > maxLength
            ? text.substring(0, maxLength) + "..."
            : text;
        return (
          <span className="rowStyle no-wrap" title={text}>
            {truncatedText}
          </span>
        );
      },
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.auditor.svg} alt="icon" />
            Auditor
          </div>
        );
      },
      dataIndex: "auditor",
      render: (auditor) => <AvatarCell avt={auditor} showRole={false} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.agent.svg} alt="icon" />
            Agent
          </div>
        );
      },
      dataIndex: "agent",
      render: (agent) => <AvatarCell avt={agent} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle no-wrap">
            <img src={media.supervisor.svg} alt="icon" />
            TL
          </div>
        );
      },
      dataIndex: "supervisor",
      render: (supervisor) => <AvatarCell avt={supervisor} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle no-wrap">
            <img src={media.supervisor.svg} alt="icon" />
            ATL
          </div>
        );
      },
      dataIndex: "atl",
      render: (atl) => <AvatarCell avt={atl} />,
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Audit Date
          </div>
        );
      },
      dataIndex: "createdAt",
      render: (text) => (
        <span className="rowStyle no-wrap">
          {text && moment(text).format("ddd, DD MMM YYYY HH:mm:ss")}
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentDate.svg} alt="icon" />
            Transaction Date
          </div>
        );
      },
      dataIndex: "transaction_date",
      render: (text) => (
        <span className="rowStyle no-wrap">
          {text && moment(text).format("ddd, DD MMM YYYY")}
        </span>
      ),
    },

    {
      title: () => {
        return (
          <div className="tableTitle">
            <img src={media.departmentStatus.svg} alt="icon" />
            Status
          </div>
        );
      },
      dataIndex: "stage",
      render: (text) => (
        <span className="rowStyle no-wrap">
          <span
            className={`cusStatus ${
              text === "Audit Completed"
                ? "cusActive"
                : text === "Audit Pending"
                  ? "cusInActive"
                  : text === "Accepted"
                    ? "cusActive"
                    : "statusDisputed"
            }`}
          >
            {text}
          </span>
        </span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle  no-wrap">
            <img src={media.auditScoree.svg} alt="icon" />
            Score
          </div>
        );
      },
      dataIndex: "score",
      render: (text, row) => (
        <span className="rowStyle no-wrap tableBtn bfont">{text}%</span>
      ),
    },
    {
      title: () => {
        return (
          <div className="tableTitle  no-wrap  ">
            <img src={media.activeAudits.svg} alt="icon" />
            Active
          </div>
        );
      },
      dataIndex: "active",
      render: (text) => (
        <span
          className={
            text?.toUpperCase() === "ACTIVE"
              ? "cusStatus cusActive"
              : "cusStatus cusClosed"
          }
        >
          {text && text?.toLowerCase()}
        </span>
      ),
    },
    {
      title: () => {
        return <div className="tableTitle"> </div>;
      },
      dataIndex: "comments",
      render: (text) => (
        <span className="rowStyle no-wrap">
          {" "}
          <img
            src={text > 0 ? "comment.png" : "noComment.png"}
            style={{ width: "17px" }}
            alt="logo"
          />
          &nbsp;{text}
        </span>
      ),
    },
  ];

  useEffect(() => {
    const role = secureLocalStorage.getItem("role");

    const canLoadData =
      role === "qc" ||
      role === "auditor" ||
      ((role === "admin" || role === "tl" || role === "atl") &&
        auditType === process.env.REACT_APP_OPS_AUDITYPE);

    if (canLoadData) {
      getDepartments();
    }
  }, [auditType]);

  useEffect(() => {
    if (departmentId !== undefined) {
      getProcesses();
      getClients();
    }
    if (processId !== undefined) {
      getForms();
    }
    if (clientId !== undefined) {
      getAgents();
    }
  }, [
    departmentId,
    processId,
    clientId,
    transactionId,
    transactionDate,
    agentId,
    auditFor,
  ]);

  /*Audit Date*/
  var today = moment();
  var valid = function (current) {
    return current.isBefore(today);
  };

  /*Audit Date*/

  const [backAuditDateChecked, setBackAuditDateChecked] = useState(false);

  const handleCheckboxChange = (e) => {
    setBackAuditDateChecked(e.target.checked);
  };

  const [form] = Form.useForm();

  const handleCreate = () => {
    form
      .validateFields()
      .then((values) => {
        onCreate(values);
      })
      .catch((info) => {
        console.log("Validate Failed:", info);
      });
  };

  {
    /*begin:: Download all audits*/
  }
  const onCreateDownloadAll = async (values) => {
    secureLocalStorage.setItem("isActiveLoad", "activeLoad");
    const month = values?.month.format("YYYY-MM");

    try {
      let hasSearchedValue, searchKeyword;
      if (secureLocalStorage.getItem("hasSearchedValue")) {
        hasSearchedValue = "yes";
        searchKeyword = secureLocalStorage.getItem("searchKeyword");
      } else {
        hasSearchedValue = "";
        searchKeyword = "";
      }

      const response = await dispatch(
        downloadAllThunk({
          searchKeyword,
          month,
          role: secureLocalStorage.getItem("role"),
          lIUId: secureLocalStorage.getItem("lIUId"),
          exportOf: "audit",
          exportColumns,
          auditType: secureLocalStorage.getItem("auditType"),
        }),
      ).unwrap();

      // Check if the response data is a Blob
      if (response instanceof Blob) {
        // Create a Blob from the response
        const blob = new Blob([response], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        // Create a link element
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = "audits.xlsx";

        // Append to the DOM
        document.body.appendChild(link);

        // Trigger the download
        link.click();

        // Revoke the Blob URL after the download
        window.URL.revokeObjectURL(link.href);

        // Clean up
        document.body.removeChild(link);

        message.success("Download done successfully");
        setIsDownloadModalOpen(false);
        secureLocalStorage.setItem("isActiveLoad", "");
      } else {
        console.error("Expected a Blob, but got:", response);
      }
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const handleDownloadAll = async () => {
    secureLocalStorage.setItem("isActiveLoad", "false");
    setIsDownloadModalOpen(true);
  };

  {
    /*end: Download all audits*/
  }

  // Disable dates after the current date
  const disableFutureDates = (current) => {
    const startDate = moment(current).subtract(1, "month").startOf("day");

    // Calculate the end date for the next financial year
    const currentYear = moment().year();
    const nextFinancialYearEnd = moment()
      .month(2)
      .date(31)
      .year(
        currentYear + (moment().isAfter(moment().month(2).date(31)) ? 1 : 0),
      )
      .endOf("day");

    // Disable dates outside the range two months ago from today to next financial year's 31st March
    return (
      current &&
      (current.isBefore(startDate) || current.isAfter(moment().endOf("day")))
    );
  };

  const isAdmin = secureLocalStorage.getItem("role") === "admin";
  const isAuditor = secureLocalStorage.getItem("role") === "auditor";
  const isQC = secureLocalStorage.getItem("role") === "qc";
  const isTL = secureLocalStorage.getItem("role") === "tl";
  const isATL = secureLocalStorage.getItem("role") === "atl";
  const isQCSupervisor = isQC && secureLocalStorage.getItem("manager") === null;

  const hasSelectedRows =
    Array.isArray(globalState.selectedRowKeysChildInfo) &&
    globalState.selectedRowKeysChildInfo.length > 0;

  const canPerformAudit =
    (isAdmin && currentAuditSection === "qMSAuditsMy") ||
    (isAuditor && currentAuditSection === "qMSAudits") ||
    (isQC && currentAuditSection === "qMSAuditsAuditors") ||
    ((isTL || isATL) && currentAuditSection === "qMSAuditsOps");

  const hasPerformAuditAccess =
    canPerformAudit &&
    hasPermission(accessMap, currentAuditSection, "PERFORMNEWAUDIT");
  if (!hasViewAccess) {
    return <Unauthorized />;
  }

  return (
    <>
      <div className="all-content">
        <CustomLoader showLoader={showLoader} />
        <>
          <TopContainerHeader
            sectionTitle="Audits"
            sectionDescription={
              showLoader ? "Loading..." : `${count || 0} Found`
            }
            hasSectionButton={hasPermission(accessMap, currentAuditSection, [
              "DELETE",
              "DOWNLOADASEXCEL",
              "MARKASCOMPLETE",
              "DOWNLOADALL",
              "PERFORMNEWAUDIT",
            ])}
            sectionButtons={[
              {
                isVisible:
                  // (isAdmin || isAuditor || isQC) &&
                  hasSelectedRows &&
                  hasPermission(
                    accessMap,
                    currentAuditSection,
                    "DOWNLOADASEXCEL",
                  ),
                itemType: "downloadAsExcel",
                itemName: "",
                renderComponent: (
                  <JsonToExcel
                    title={
                      <>
                        <img src={media.downloadIcon.svg} alt="icon" />
                        &nbsp;Download as Excel
                      </>
                    }
                    data={
                      Array.isArray(globalState.exportAuditReportJson)
                        ? globalState.exportAuditReportJson
                        : []
                    }
                    fileName="auditReport"
                    btnClassName="defaultBtn defaultGreyBtn"
                  />
                ),
                itemClassName: "",
              },
              {
                isVisible:
                  (isAdmin || isQCSupervisor || isQC) &&
                  hasSelectedRows &&
                  hasPermission(accessMap, currentAuditSection, "DELETE"),
                itemType: "",
                itemName: "Delete",
                itemClassName: "auditDelete defaultGreyBtn",
                itemIcon: <i className="fa fa-trash" aria-hidden="true"></i>,
                onClick: () => handleAuditAction("delete"),
              },
              {
                isVisible:
                  (isAdmin || isQC) &&
                  hasSelectedRows &&
                  hasPermission(
                    accessMap,
                    currentAuditSection,
                    "MARKASCOMPLETE",
                  ),
                itemType: "",
                itemName: "Mark as Complete",
                itemClassName: "auditComplete defaultGreyBtn",
                itemIcon: (
                  <i className="fa fa-check-square-o" aria-hidden="true"></i>
                ),
                onClick: () => handleAuditAction("complete"),
              },
              {
                isVisible: hasPermission(
                  accessMap,
                  currentAuditSection,
                  "DOWNLOADALL",
                ),
                itemType: "",
                itemName: "Download All",
                itemClassName: "downloadAllLoader-container defaultGreyBtn",
                itemIcon: <img src={media.downloadIcon.svg} alt="icon" />,
                onClick: () => handleDownloadAll(),
              },
              {
                isVisible: hasPerformAuditAccess,
                itemType: "add",
                itemName: "Perform New Audit",
                itemClassName: "performAudit",
                onClick: () => showModal(),
              },
            ]}
            hasFilter={false}
            buttonTitle="Add New"
          />
          <div className="">
            {(isAdmin || isAuditor || isQC) && (
              <>
                {/*Delete, Mark as Complete and Download All*/}
                {/* {(isAdmin || isQCSupervisor) && hasSelectedRows && (
                  <span
                    className="auditDelete table-buttons"
                    onClick={() => {
                      handleAuditAction("delete");
                    }}
                  >
                    Delete
                  </span>
                )}
                {(isAdmin || isQC) && hasSelectedRows && (
                  <span
                    className="auditComplete table-buttons"
                    onClick={() => {
                      handleAuditAction("complete");
                    }}
                  >
                    Mark as Complete
                  </span>
                )} */}
              </>
            )}

            <DownloadAllModal
              open={isDownloadModalOpen}
              setVisible={setIsDownloadModalOpen}
              headermodaltitle="Download Audit Report"
              onCreate={onCreateDownloadAll}
            />

            {(isAdmin || isAuditor || isQC || isTL || isATL) && (
              <>
                {/*Perform New Audit*/}
                <Modal
                  className="all-modal modal-lg"
                  onCancel={handleCancel}
                  onOk={handleOk}
                  title={
                    <div className="headermodaltitle">Perform New Audit</div>
                  }
                  open={isModalOpen}
                  footer={[
                    <div className="modalBtns">
                      <Button
                        key="back"
                        className="defaultBtn defaultGreyBtn"
                        onClick={handleCancel}
                      >
                        Cancel
                      </Button>
                      <Button
                        key="submit"
                        className="defaultBtn"
                        onClick={handleOk}
                      >
                        Perform Audit
                      </Button>
                    </div>,
                  ]}
                >
                  <div id="antdformstyle" className="performAuditForm">
                    <div className="formtitle formtitle pb-16 pb-0">
                      Audit Details
                    </div>
                    <Row className="performNewAudits" gutter={[12, 12]}>
                      {slsRole === "tl" && (
                        <Col xs={24} sm={24} md={12} lg={12}>
                          <label className="form-label-antd">
                            Audit For <span style={{ color: "red" }}>*</span>
                          </label>

                          <Select
                            value={auditFor || undefined}
                            placeholder="Select Audit Type"
                            options={[
                              { label: "Agent", value: "agent" },
                              { label: "ATL", value: "atl" },
                            ]}
                            onChange={(val) => {
                              setAuditFor(val);

                              // reset dropdown
                              setAgentId("");
                              setAgentCVal("");
                              setAgents([]);

                              setAuditFormErrors((state) => ({
                                ...state,
                                auditFor: "",
                                agentId: "",
                              }));

                              setAuditFormInput({
                                ...auditFormInput,
                                auditFor: {
                                  icon: "auditAgent",
                                  value: val === "atl" ? "ATL" : "Agent",
                                },
                              });
                            }}
                          />

                          {auditFormErrors?.auditFor && (
                            <div className="error">
                              {auditFormErrors?.auditFor}
                            </div>
                          )}
                        </Col>
                      )}
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Department <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          showSearch
                          allowClear
                          placeholder="Choose a Department"
                          optionFilterProp="children"
                          onChange={(val, option) => {
                            setClientId("");
                            setClients([]);

                            setAgentId("");
                            setAgentCVal("");
                            setAgents([]);

                            setProcessDepCVal("");
                            setProcessId("");
                            setTasks([]);

                            setAformVal("");
                            setFormId("");
                            setForms([]);

                            setAuditFormInput({
                              ...auditFormInput,
                              Department: {
                                icon: "auditDepartment",
                                value: option?.label,
                              },
                            });
                            setDepartmentId(val);
                            setAuditFormErrors((state) => ({
                              ...state,
                              department: option?.label
                                ? ""
                                : "Department is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options={departments}
                        />
                        {auditFormErrors?.department && (
                          <div className="error">
                            {auditFormErrors?.department}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Client <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={clientId || undefined}
                          showSearch
                          allowClear
                          placeholder="Choose a Client"
                          optionFilterProp="children"
                          onChange={(val, option) => {
                            setAgentCVal("");
                            setAgentId("");
                            setAgents([]);

                            setAuditFormInput({
                              ...auditFormInput,
                              Client: {
                                icon: "auditClient",
                                value: option?.label,
                              },
                            });
                            setClientId(val);
                            setAuditFormErrors((state) => ({
                              ...state,
                              client: option?.label ? "" : "Client is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options={clients}
                        />
                        {auditFormErrors?.client && (
                          <div className="error">{auditFormErrors?.client}</div>
                        )}
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Process <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={processId || undefined}
                          showSearch
                          allowClear
                          placeholder="Choose a Process"
                          optionFilterProp="children"
                          onChange={(val, option) => {
                            setAformVal("");
                            setFormId("");
                            setAuditFormInput({
                              ...auditFormInput,
                              Process: {
                                icon: "auditProcess",
                                value: option?.label,
                              },
                            });
                            setProcessDepCVal(val);
                            setProcessId(val);
                            setAuditFormErrors((state) => ({
                              ...state,
                              process: option?.label
                                ? ""
                                : "Process is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options={tasks}
                        />
                        {auditFormErrors?.process && (
                          <div className="error">
                            {auditFormErrors?.process}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Form <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          value={aformVal || undefined}
                          showSearch
                          allowClear
                          placeholder="Choose a Form"
                          optionFilterProp="children"
                          onChange={(val, option) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              "Audit Form": {
                                icon: "auditForm",
                                value: option?.label,
                              },
                            });
                            setAformVal(val);
                            setFormId(val);
                            setAuditFormErrors((state) => ({
                              ...state,
                              auditForm: option?.label
                                ? ""
                                : "Form is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options={forms}
                        />
                        {auditFormErrors?.auditForm && (
                          <div className="error">
                            {auditFormErrors?.auditForm}
                          </div>
                        )}
                      </Col>
                    </Row>
                    <div className="formtitle plr-16">Transaction Details</div>
                    <Row className="performNewAudits" gutter={[12, 12]}>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Transaction Amount
                        </label>
                        <Input
                          placeholder="Enter the Transaction Amount"
                          onChange={(e) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              "Transaction Amount": {
                                icon: "auditTransaction",
                                value: e.target.value,
                              },
                            });
                            setTransactionAmount(e.target.value);
                            setAuditFormErrors((state) => ({
                              ...state,
                              transactionAmount: "",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          onBlur={() => {
                            let error = "";

                            if (!transactionAmount) {
                              error = "Transaction Amount is required";
                            } else if (!/^\d+$/.test(transactionAmount)) {
                              error = "Only numbers are allowed";
                            }

                            setAuditFormErrors((state) => ({
                              ...state,
                              transactionAmount: error,
                            }));
                          }}
                        />
                        {auditFormErrors?.transactionAmount && (
                          <div className="error">
                            {auditFormErrors?.transactionAmount}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">Invoice Count</label>
                        <Input
                          placeholder="Enter the Invoice Count"
                          onChange={(e) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              "Invoice Count": {
                                icon: "auditInsure",
                                value: e.target.value,
                              },
                            });

                            setAuditFormErrors((state) => ({
                              ...state,
                              invoiceCount: "",
                            }));
                            setInvoiceCount(e.target.value);
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          onBlur={() => {
                            let error = "";

                            if (!invoiceCount) {
                              error = "Invoice Count is required";
                            } else if (!/^\d+$/.test(invoiceCount)) {
                              error = "Only numbers are allowed";
                            }

                            setAuditFormErrors((state) => ({
                              ...state,
                              invoiceCount: error,
                            }));
                          }}
                        />
                        {auditFormErrors?.invoiceCount && (
                          <div className="error">
                            {auditFormErrors?.invoiceCount}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Insured Name <span style={{ color: "red" }}>*</span>
                        </label>
                        <Input
                          placeholder="Enter the Insured Name"
                          onChange={(e) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              "Insured Name": {
                                icon: "auditInsure",
                                value: e.target.value,
                              },
                            });
                            setInsuredName(e.target.value);
                            setAuditFormErrors((state) => ({
                              ...state,
                              insuredName: e.target.value
                                ? ""
                                : "Insured Name is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          onBlur={() => {
                            setAuditFormErrors((state) => ({
                              ...state,
                              insuredName: insuredName
                                ? ""
                                : "Insured Name is required",
                            }));
                          }}
                        />
                        {auditFormErrors?.insuredName && (
                          <div className="error">
                            {auditFormErrors?.insuredName}
                          </div>
                        )}
                      </Col>

                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          {" "}
                          {slsRole === "tl"
                            ? auditFor === "atl"
                              ? "ATL"
                              : "Agent"
                            : "Agent"}{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <Select
                          disabled={slsRole === "tl" && !auditFor}
                          value={agentCVal || undefined}
                          showSearch
                          allowClear
                          placeholder={`Choose a ${
                            slsRole === "tl"
                              ? auditFor === "atl"
                                ? "ATL"
                                : "Agent"
                              : "Agent"
                          }`}
                          optionFilterProp="children"
                          onChange={(val, option) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              agent: {
                                icon: "auditAgent",
                                value: option?.label,
                              },
                            });

                            setAgentId(val);
                            setAgentCVal(val);
                            setAuditFormErrors((state) => ({
                              ...state,
                              agentId: option?.label
                                ? ""
                                : `${
                                    slsRole === "tl" && auditFor === "atl"
                                      ? "ATL"
                                      : "Agent"
                                  } is required`,
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          filterOption={(input, option) =>
                            (option?.label ?? "")
                              ?.toLowerCase()
                              .includes(input?.toLowerCase())
                          }
                          options={agents}
                        />
                        {auditFormErrors?.agentId && (
                          <div className="error">
                            {auditFormErrors?.agentId}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Transaction ID <span style={{ color: "red" }}>*</span>
                        </label>
                        <Input
                          placeholder="Enter the Transaction ID"
                          onChange={(e) => {
                            setAuditFormInput({
                              ...auditFormInput,
                              Transaction: {
                                icon: "auditTransaction",
                                value: e.target.value,
                              },
                            });
                            setTransactionId(e.target.value);
                            setAuditFormErrors((state) => ({
                              ...state,
                              transactionId: e.target.value
                                ? ""
                                : "Transaction ID is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                        />
                        {auditFormErrors?.transactionId && (
                          <div className="error">
                            {auditFormErrors?.transactionId}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <label className="form-label-antd">
                          Transaction Date{" "}
                          <span style={{ color: "red" }}>*</span>
                        </label>
                        <DatePicker
                          disabledDate={disableFutureDates}
                          onChange={(date) => {
                            setTransactionDate(date);
                            setAuditFormInput({
                              ...auditFormInput,
                              "Transaction Date": {
                                icon: "auditCalendar",
                                value: date,
                              },
                            });
                            setAuditFormErrors((state) => ({
                              ...state,
                              transactionDate: date
                                ? ""
                                : "Transaction Date is required",
                            }));
                            secureLocalStorage.setItem(
                              "auditFormInput",
                              auditFormInput,
                            );
                          }}
                          value={transactionDate}
                        />
                        {auditFormErrors?.transactionDate && (
                          <div className="error">
                            {auditFormErrors?.transactionDate}
                          </div>
                        )}
                      </Col>
                      <Col xs={24} sm={24} md={12} lg={12}>
                        <div className="form-label-antd">
                          <Checkbox
                            checked={backAuditDateChecked}
                            onChange={handleCheckboxChange}
                            className="form-label-antd"
                          >
                            Is Audit's Back date?
                          </Checkbox>
                        </div>
                      </Col>
                    </Row>
                  </div>
                </Modal>
              </>
            )}
          </div>
        </>

        <div className="all-table-holder">
          <TableContent
            rowSelection={{
              type: selectionType,
              ...rowSelection,
            }}
            rowClassName={(record, index) =>
              record.auditBackDateReason ? "auditBackDateReasonRow" : ""
            }
            bordered={false}
            columns={columns}
            dataSource={list}
            pagination={tablePagination}
          />
        </div>
      </div>
      <AuditBackDateReasonForm
        open={auditBackDateReasonVisible}
        setVisible={setAuditBackDateReasonVisible}
        onCreate={onCreateBackDateReason}
      />

      <DuplicateTransactionReasonForm
        open={visible}
        setVisible={setVisible}
        onCreate={onCreate}
      />

      {/*Confirmation Modal before submitting Perform an Audit's form*/}
      <Modal
        title="Confirmation!"
        open={isModalVisible}
        onOk={handleOk}
        onCancel={() => {
          setIsModalVisible(false);
          setIsModalOpen(true);
        }}
        okText="OK"
        cancelText="Cancel"
        className="audtModal"
        footer={
          <div className="modalBtns">
            <Button
              className="defaultBtn defaultGreyBtn"
              onClick={() => {
                setIsModalVisible(false);
                setIsModalOpen(true);
              }}
            >
              Cancel
            </Button>

            <Button type="primary" className="defaultBtn" onClick={handleOk}>
              OK
            </Button>
          </div>
        }
      >
        <p className="pb-16">
          Please review your selected or entered information carefully before
          submitting the form, as changes may not be possible once it's
          submitted.
        </p>
      </Modal>

      {/*Audit Delete Modal for Admin Role*/}
      <Modal
        title="Confirmation!"
        closable={!showLoader}
        maskClosable={!showLoader}
        open={isDeleteModalVisible}
        onCancel={() => setIsDeleteModalVisible(false)}
        className="audtModal"
        footer={
          secureLocalStorage.getItem("role") === "qc" ? (
            <div className="modalBtns">
              <Button
                className="defaultBtn"
                onClick={() => handleAuditAction("delete")}
              >
                Submit
              </Button>
            </div>
          ) : (
            <div className="modalBtns">
              <Button
                className="defaultBtn defaultGreyBtn"
                onClick={() => setIsDeleteModalVisible(false)}
              >
                No
              </Button>
              <Button
                className="defaultBtn"
                onClick={() => handleAuditAction("delete")}
              >
                Yes
              </Button>
            </div>
          )
        }
      >
        {secureLocalStorage.getItem("role") === "qc" ? (
          <Form form={form}>
            <Form.Item
              className="auditDeleteReason pb-16 mb-0"
              label={
                <span className="auditDeleteReason-label">
                  Provide reason for deleting
                </span>
              }
              name="auditDeleteReason"
              rules={[{ required: true, message: "Please input the reason!" }]}
            >
              <Input.TextArea rows={2} />
            </Form.Item>
          </Form>
        ) : (
          <p className="pb-16 mb-0">
            Are you sure you want to delete this audit?
          </p>
        )}
      </Modal>
    </>
  );
};
export default Audits;
